import { type TFunction } from "i18next";

/**
 * Legal document titles arrive either as slugs ("terms-and-conditions") or as
 * human titles ("Terms and Conditions"). Both resolve to the same key.
 */
export const getContractKey = (title: string) =>
  title.trim().toLowerCase().replace(/\s+/g, "-");

export const getContractLabelText = (
  title: string,
  clientName: string,
  t: TFunction
) => {
  const key = getContractKey(title);

  if (key === "terms-and-conditions") {
    return t("terms_termsAndConditions");
  } else if (key === "privacy-policy") {
    return t("privacy_policy");
  } else if (key.endsWith("-privacy-policy")) {
    return t("client_privacy", { client: clientName });
  } else if (key === "card-holder-agreement") {
    return t("card_agreement");
  }
  // Unhandled key
  return title;
};
